<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<ChangeStatus
			v-if="modalType === ModalType.CHANGE_STATUS"
			:active-mode="activeMode"
			:isStudent="false"
			:staff="staff"
			@active="activeStaff"
			@block="closeStaff"
			@close="modalIsOpen = false"
		/>
		<ChangeStatusAssignedDaycareClass
			v-if="
				modalType === ModalType.ERROR && errorAssignedDayClasses.length
			"
			:data="errorAssignedDayClasses"
			@close="modalIsOpen = false"
		/>
		<ChangeStatusAssigned
			v-if="modalType === ModalType.ERROR && errorAssigned.length"
			:data="errorAssigned"
			@close="modalIsOpen = false"
		/>
		<LeaveReport v-if="modalType === ModalType.LEAVE_REPORT" />
	</DaModalFrame>
	<div class="__employee-detail p-10 pb-30 md-down:px-4">
		<div v-if="!isLoading">
			<div
				class="__breadcrumbs text-sm text-neutral-500 font-semibold flex-nowrap flex items-center"
			>
				<router-link :to="{ name: routerName.RECORD_EMPLOYEE }">
					Hồ sơ
				</router-link>
				<div class="__breadcrumbs__decorate">
					<DaIcon
						class="transform -rotate-90 h-3 w-3 mx-2"
						name="das--chevron-down"
					/>
				</div>
				<div>Hồ sơ nhân sự</div>
			</div>
			<div
				class="__employee-detail__header pt-10 pb-10 flex items-center justify-between"
			>
				<div class="flex items-center">
					<div class="relative">
						<img
							v-if="staff?.profile_photo?.w200"
							:src="staff?.profile_photo?.w200"
							alt=""
							class="shadow-sm inline-block h-14 w-14 rounded-full"
							style="min-width: 56px"
						/>
						<span
							v-else
							:style="{
								background:
									staff?.profile_photo?.default?.color,
							}"
							class="inline-flex items-center justify-center h-14 w-14 rounded-full"
							style="min-width: 56px"
						>
							<span
								class="font-medium leading-none text-white text-xl"
								>{{
									staff?.profile_photo?.default?.initial
								}}</span
							>
						</span>
						<div
							v-if="staff.state !== 'active'"
							class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 h-14 w-14 rounded-full flex items-center justify-center"
							style="
								min-width: 56px;
								background-color: rgba(99, 144, 195, 0.5);
							"
						>
							<svg
								fill="none"
								height="32"
								viewBox="0 0 40 40"
								width="32"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									clip-rule="evenodd"
									d="M9.84364 16.0997V10.2496C9.84364 4.86466 14.3907 0.5 20 0.5C25.6093 0.5 30.1564 4.865 30.1564 10.2496V16.0997C33.5218 16.0997 36.25 18.7188 36.25 21.9497V33.6499C36.25 36.8812 33.5218 39.5 30.1564 39.5H9.84364C6.47821 39.5 3.75 36.8812 3.75 33.6499V21.9497C3.75 18.7188 6.47821 16.0997 9.84364 16.0997V16.0997ZM26.0936 16.0997V10.2496C26.0936 7.01866 23.3654 4.3995 20 4.3995C16.6346 4.3995 13.9064 7.01866 13.9064 10.2496V16.0997H26.0936ZM20 23.9C21.1218 23.9 22.0311 24.7729 22.0311 25.8499V29.7501C22.0311 30.8271 21.1218 31.7 20 31.7C18.8782 31.7 17.9689 30.8271 17.9689 29.7501V25.8499C17.9689 24.7729 18.8782 23.9 20 23.9Z"
									fill="#FAF5F1"
									fill-rule="evenodd"
								/>
							</svg>
						</div>
					</div>
					<div class="ml-4">
						<div
							class="font-bold text-neutral-700 text-4xl md-down:text-2xl"
						>
							{{ staff.full_name }} | {{ staff.name }}
						</div>
						<div
							v-if="staff.state === 'active'"
							class="text-xs text-neutral-400 flex items-center flex-nowrap"
						>
							<svg
								class="mr-2"
								fill="none"
								height="12"
								viewBox="0 0 20 20"
								width="12"
							>
								<path
									clip-rule="evenodd"
									d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM15.0379 6.21209C14.6718 5.84597 14.0782 5.84597 13.7121 6.21209C13.7032 6.22093 13.6949 6.23029 13.6872 6.24013L9.34673 11.7709L6.72983 9.15403C6.36372 8.78791 5.77012 8.78791 5.40401 9.15403C5.03789 9.52015 5.03789 10.1137 5.40401 10.4799L8.71207 13.7879C9.07818 14.154 9.67178 14.154 10.0379 13.7879C10.046 13.7798 10.0537 13.7712 10.0609 13.7622L15.0512 7.52434C15.404 7.15727 15.3995 6.57371 15.0379 6.21209Z"
									fill="#41BEAD"
									fill-rule="evenodd"
								/>
							</svg>
							TÀI KHOẢN ĐÃ KÍCH HOẠT
						</div>
						<div
							v-if="staff.state !== 'active'"
							class="text-xs text-neutral-400 flex items-center flex-nowrap"
						>
							<svg
								class="mr-2"
								fill="none"
								height="12"
								viewBox="0 0 20 20"
								width="12"
							>
								<path
									clip-rule="evenodd"
									d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.83333 9.16667C5.48815 9.16667 5.20833 9.53976 5.20833 10C5.20833 10.4602 5.48815 10.8333 5.83333 10.8333H14.5833C14.9285 10.8333 15.2083 10.4602 15.2083 10C15.2083 9.53976 14.9285 9.16667 14.5833 9.16667H5.83333Z"
									fill="#E68D7B"
									fill-rule="evenodd"
								/>
							</svg>
							TÀI KHOẢN ĐÃ KHÓA
						</div>
					</div>
				</div>
				<div v-if="false" class="flex items-center">
					<button
						class="button-p text-center mt-6 btn--ghost"
						type="button"
						@click="openModel(ModalType.LEAVE_REPORT)"
					>
						Báo nghỉ
					</button>
					<button
						class="button-p text-center mt-6 whitespace-nowrap ml-4 btn--ghost"
						type="button"
					>
						Xem lịch dạy
					</button>
				</div>
			</div>
			<div class="__employee-detail__container">
				<div>
					<div class="border-b border-neutral-200">
						<nav
							aria-label="Tabs"
							class="-mb-px flex space-x-8 tabs"
						>
							<div
								v-if="
									!notAnalytics &&
									staff.has_assignment &&
									centerState !== 'community'
								"
								:class="{
									selected:
										tab ===
										routerName.RECORD_EMPLOYEE_STATS,
								}"
								class="border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"
								@click="
									selectTab(routerName.RECORD_EMPLOYEE_STATS)
								"
							>
								Thống kê
								<span
									v-if="
										staff.has_assignment &&
										staff.has_staff_day_care_membership
									"
									>Can Thiệp</span
								>
							</div>
							<div
								v-if="
									!notAnalytics &&
									staff.has_staff_day_care_membership &&
									centerState !== 'community'
								"
								:class="{
									selected:
										tab ===
										routerName.RECORD_EMPLOYEE_STATS_DAYCARE,
								}"
								class="border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"
								@click="
									selectTab(
										routerName.RECORD_EMPLOYEE_STATS_DAYCARE
									)
								"
							>
								Thống kê
								<span
									v-if="
										staff.has_assignment &&
										staff.has_staff_day_care_membership
									"
									>Bán trú</span
								>
							</div>
							<div
								:class="{
									selected:
										tab ===
										routerName.RECORD_EMPLOYEE_DETAIL_INFO,
								}"
								class="border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"
								@click="
									selectTab(
										routerName.RECORD_EMPLOYEE_DETAIL_INFO
									)
								"
							>
								Thông tin cá nhân
							</div>
							<div
								v-if="!isLitePackage"
								:class="{
									selected:
										tab === routerName.RECORD_EMPLOYEE_FILE,
								}"
								class="border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"
								@click="
									selectTab(routerName.RECORD_EMPLOYEE_FILE)
								"
							>
								Hồ sơ
							</div>
						</nav>
					</div>
				</div>
				<div class="mt-6">
					<div v-if="tab === routerName.RECORD_EMPLOYEE_STATS">
						<div v-if="!notAnalytics" class="w-full">
							<div>
								<div class="relative mt-16">
									<div
										aria-hidden="true"
										class="absolute inset-0 flex items-center"
									>
										<div
											class="w-full border-t border-neutral-300"
										/>
									</div>
									<div class="relative flex justify-center">
										<div
											class="bg-body px-2 text-neutral-600 font-semibold text-2xl whitespace-nowrap flex flex-nowrap items-center justify-center gap-6"
										>
											<div
												v-if="
													date.month > 0 ||
													date.year > 2023
												"
												class="cursor-pointer"
												@click="prevDay"
											>
												<svg
													fill="none"
													height="12"
													viewBox="0 0 8 12"
													width="8"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M6.5 1L1.5 6L6.5 11"
														stroke="#48566A"
														stroke-linecap="round"
														stroke-linejoin="round"
														stroke-width="2"
													/>
												</svg>
											</div>
											<VueDatepicker
												v-model="date"
												:max-date="new Date()"
												:min-date="new Date(2023, 1, 0)"
												auto-apply
												class="input-date-dashboard"
												format="MM/yyyy"
												month-picker
												placeholder="Chọn tháng"
												uid="filter-by-date"
											>
												<template #trigger>
													<div
														v-if="date"
														class="flex items-center gap-2.5 cursor-pointer"
													>
														<svg
															fill="none"
															height="16"
															viewBox="0 0 17 16"
															width="17"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																clip-rule="evenodd"
																d="M4.5 0.5C4.5 0.223858 4.27614 0 4 0C3.72386 0 3.5 0.223858 3.5 0.5V1H2.5C1.39543 1 0.5 1.89543 0.5 3V4H16.5V3C16.5 1.89543 15.6046 1 14.5 1H13.5V0.5C13.5 0.223858 13.2761 0 13 0C12.7239 0 12.5 0.223858 12.5 0.5V1H4.5V0.5ZM16.5 14V5H0.5V14C0.5 15.1046 1.39543 16 2.5 16H14.5C15.6046 16 16.5 15.1046 16.5 14ZM10 7C9.72386 7 9.5 7.22386 9.5 7.5V8.5C9.5 8.77614 9.72386 9 10 9H11C11.2761 9 11.5 8.77614 11.5 8.5V7.5C11.5 7.22386 11.2761 7 11 7H10ZM13 7C12.7239 7 12.5 7.22386 12.5 7.5V8.5C12.5 8.77614 12.7239 9 13 9H14C14.2761 9 14.5 8.77614 14.5 8.5V7.5C14.5 7.22386 14.2761 7 14 7H13ZM2.5 10.5C2.5 10.2239 2.72386 10 3 10H4C4.27614 10 4.5 10.2239 4.5 10.5V11.5C4.5 11.7761 4.27614 12 4 12H3C2.72386 12 2.5 11.7761 2.5 11.5V10.5ZM6 10C5.72386 10 5.5 10.2239 5.5 10.5V11.5C5.5 11.7761 5.72386 12 6 12H7C7.27614 12 7.5 11.7761 7.5 11.5V10.5C7.5 10.2239 7.27614 10 7 10H6Z"
																fill="#48566A"
																fill-rule="evenodd"
															/>
														</svg>
														<span
															>Tháng
															{{
																dateTitle
															}}</span
														>
													</div>
												</template>
											</VueDatepicker>
											<div
												v-if="
													date.month <
														new Date().getMonth() ||
													date.year <
														new Date().getFullYear()
												"
												class="cursor-pointer"
												@click="nextDay"
											>
												<svg
													fill="none"
													height="12"
													viewBox="0 0 8 12"
													width="8"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M1.5 11L6.5 6L1.5 1"
														stroke="#48566A"
														stroke-linecap="round"
														stroke-linejoin="round"
														stroke-width="2"
													/>
												</svg>
											</div>
										</div>
									</div>
								</div>
								<div class="mt-10" v-if="!isLitePackage">
									<div class="font-semibold text-neutral-500">
										Chuyên cần theo giờ
									</div>
									<div
										class="grid grid-cols-4 items-start md-down:grid-cols-1 mt-2 gap-4"
									>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 4.375C10 4.02982 9.72018 3.75 9.375 3.75C9.02982 3.75 8.75 4.02982 8.75 4.375V11.25C8.75 11.4743 8.87018 11.6814 9.06491 11.7927L13.4399 14.2927C13.7396 14.4639 14.1214 14.3598 14.2927 14.0601C14.4639 13.7604 14.3598 13.3786 14.0601 13.2073L10 10.8873V4.375Z"
															fill="#6366F1"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>
													Số giờ đã dạy / giờ dự kiến
												</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.session_stats
														?.total_created_hours
												}}/
												{{
													dataStats?.session_stats
														?.total_scheduled_hours
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 24 20"
														width="24"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z"
															fill="#F1A267"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z"
															fill="#F1A267"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Số giờ dạy phát sinh</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.session_stats
														?.total_unscheduled_hours
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 24 20"
														width="24"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z"
															fill="#E68D7B"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z"
															fill="#E68D7B"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>
													Số giờ {{ $filters.terminology('teacher') }} nghỉ
												</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.session_stats
														?.total_cancelled_by_staff_hours
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 24 20"
														width="24"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z"
															fill="#E68D7B"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z"
															fill="#E68D7B"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Số giờ học sinh nghỉ</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.session_stats
														?.total_cancelled_by_student_hours
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="mt-10" v-if="!isLitePackage">
									<div class="font-semibold text-neutral-500">
										Chuyên cần theo ngày
									</div>
									<div
										class="grid grid-cols-3 items-start md-down:grid-cols-1 mt-2 gap-4"
									>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 4.375C10 4.02982 9.72018 3.75 9.375 3.75C9.02982 3.75 8.75 4.02982 8.75 4.375V11.25C8.75 11.4743 8.87018 11.6814 9.06491 11.7927L13.4399 14.2927C13.7396 14.4639 14.1214 14.3598 14.2927 14.0601C14.4639 13.7604 14.3598 13.3786 14.0601 13.2073L10 10.8873V4.375Z"
															fill="#6366F1"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>
													Số ngày đã dạy / dự kiến
												</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.session_stats
														?.total_created_days
												}}/
												{{
													dataStats?.session_stats
														?.total_scheduled_days
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 24 20"
														width="24"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z"
															fill="#F1A267"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z"
															fill="#F1A267"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Số ngày học phát sinh</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.session_stats
														?.total_unscheduled_days
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 24 20"
														width="24"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z"
															fill="#E68D7B"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z"
															fill="#E68D7B"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Số ngày nghỉ</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.session_stats
														?.total_cancelled_days
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="mt-10">
									<div class="font-semibold text-neutral-500">
										Tiến độ công việc (hoàn thành/tổng số)
									</div>
									<div
										class="grid grid-cols-4 items-start md-down:grid-cols-1 mt-2 gap-4"
									>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z"
															fill="#41BEAD"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Báo cáo can thiệp</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats
														?.lesson_report_stats
														?.numbers_of_completed_lesson_report
												}}/{{
													dataStats
														?.lesson_report_stats
														?.numbers_of_lesson_report
												}}
											</div>
										</div>
										<div
											v-if="
												dataStats?.weekly_report_stats
											"
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z"
															fill="#41BEAD"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Báo cáo tuần</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats
														?.weekly_report_stats
														?.numbers_of_completed_weekly_report
												}}/{{
													dataStats
														?.weekly_report_stats
														?.numbers_of_weekly_report
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z"
															fill="#41BEAD"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Báo cáo tháng</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats
														?.monthly_report_stats
														?.numbers_of_completed_monthly_report
												}}/{{
													dataStats
														?.monthly_report_stats
														?.numbers_of_monthly_report
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z"
															fill="#41BEAD"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Kế hoạch dự kiến</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.plan_stats
														?.numbers_of_done_plan ||
													0
												}}/
												{{
													dataStats?.plan_stats
														?.numbers_of_plan
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="mt-10" v-if="!isLitePackage">
									<div class="font-semibold text-neutral-500">
										Hình ảnh/ Video upload
									</div>
									<div
										class="grid grid-cols-3 items-start md-down:grid-cols-1 mt-2 gap-4"
									>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-center justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 21 20"
														width="21"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M17.5019 2.5H2.50192C1.81157 2.5 1.25192 3.05964 1.25192 3.75V15L4.55998 12.0581C4.77065 11.8474 5.10072 11.8147 5.34861 11.98L8.67229 14.1958L13.31 9.55807C13.5002 9.36785 13.7908 9.32069 14.0314 9.441L18.7519 11.875V3.75C18.7519 3.05964 18.1923 2.5 17.5019 2.5ZM2.50192 1.25C1.12121 1.25 0.00192261 2.36929 0.00192261 3.75V16.25C0.00192261 17.6307 1.12121 18.75 2.50192 18.75H17.5019C18.8826 18.75 20.0019 17.6307 20.0019 16.25V3.75C20.0019 2.36929 18.8826 1.25 17.5019 1.25H2.50192ZM7.50192 6.875C7.50192 7.91053 6.66246 8.75 5.62692 8.75C4.59139 8.75 3.75192 7.91053 3.75192 6.875C3.75192 5.83947 4.59139 5 5.62692 5C6.66246 5 7.50192 5.83947 7.50192 6.875Z"
															fill="#F0BB4F"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Số hình ảnh đã upload</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.media_stats
														?.numbers_of_image
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-center justify-start gap-4"
											>
												<div>
													<div>
														<svg
															fill="none"
															height="20"
															viewBox="0 0 20 20"
															width="20"
															xmlns="http://www.w3.org/2000/svg"
														>
															<g
																clip-path="url(#clip0_16570_9419)"
															>
																<path
																	d="M18.0542 2.5H1.94598C1.69039 2.49995 1.4373 2.55273 1.20115 2.65531C0.965002 2.7579 0.750429 2.90829 0.569684 3.09789C0.388939 3.28749 0.245562 3.51259 0.147741 3.76034C0.0499209 4.00808 -0.000426956 4.27362 -0.000426952 4.54178V15.4582C-0.000567593 15.7265 0.0496765 15.9921 0.147434 16.24C0.245192 16.4879 0.388546 16.7131 0.569305 16.9028C0.750065 17.0926 0.964685 17.243 1.2009 17.3457C1.43712 17.4484 1.6903 17.5012 1.94598 17.5011H18.0542C18.5704 17.5011 19.0653 17.286 19.4303 16.9031C19.7953 16.5202 20.0003 16.0009 20.0003 15.4593V4.54178C20.0003 4.00027 19.7953 3.48093 19.4303 3.09802C19.0653 2.71512 18.5704 2.5 18.0542 2.5ZM9.0269 4.05585H10.973C10.9966 4.05679 11.0195 4.06489 11.0389 4.07917C11.0583 4.09345 11.0733 4.11331 11.0821 4.13634V5.4702H8.95554V4.19736C8.94747 4.16867 8.95042 4.1378 8.96375 4.11136C8.97709 4.08492 8.99975 4.06499 9.0269 4.05585ZM3.91594 15.9232C3.88025 15.9232 3.82495 15.943 3.78855 15.943H1.96882C1.85963 15.943 1.8054 15.9232 1.8054 15.7839V14.5302H3.91522L3.91594 15.9232ZM3.89774 5.48892H1.93313C1.9078 5.49149 1.88243 5.4843 1.86177 5.4687V4.13634C1.87997 4.09629 1.91636 4.0566 1.95276 4.0566H3.86277C3.91736 4.03676 3.95376 4.07644 3.97196 4.13634V4.17603C3.99015 4.57435 3.99015 4.97267 3.99015 5.37062C3.97053 5.43014 3.95233 5.46983 3.89774 5.49004V5.48892ZM7.46264 15.9232C7.40805 15.9232 7.37166 15.943 7.33526 15.943H5.51552C5.44416 15.9629 5.3885 15.9232 5.3521 15.8434V14.5103H7.46193L7.46264 15.9232ZM7.46264 5.50876H5.53586C5.48127 5.50876 5.44523 5.4687 5.40884 5.42902V4.09591H7.37308C7.44445 4.07607 7.50046 4.11575 7.53686 4.19549V5.3504C7.54453 5.3819 7.54128 5.41524 7.52769 5.44445C7.51409 5.47367 7.49104 5.49686 7.46264 5.50988V5.50876ZM11.0093 15.9232C10.9548 15.9232 10.9184 15.943 10.8638 15.943H9.04403C8.93485 15.943 8.89845 15.9232 8.89845 15.7839V14.6496C8.89671 14.6024 8.90287 14.5553 8.91665 14.5103H11.0083L11.0093 15.9232ZM11.3961 10.5683L9.09827 12.0568C8.63869 12.3712 8.25905 12.1406 8.25905 11.5746V8.42992C8.25905 7.84292 8.63869 7.63327 9.09827 7.94774L11.3961 9.43621C11.8557 9.7518 11.8557 10.2538 11.3961 10.5683ZM14.5575 15.8648C14.5393 15.9045 14.5029 15.9441 14.4665 15.9441H12.5397C12.504 15.9441 12.4684 15.9045 12.4487 15.8648V14.5305H14.5575V15.8648ZM14.6485 4.19549C14.6128 4.59382 14.6303 4.9723 14.6303 5.3504C14.6303 5.43014 14.6303 5.49004 14.5393 5.49004H12.5372V4.05623H14.5197C14.533 4.05243 14.547 4.05151 14.5608 4.05351C14.5745 4.05551 14.5877 4.0604 14.5996 4.06788C14.6115 4.07536 14.6218 4.08527 14.63 4.09704C14.6381 4.1088 14.6439 4.12217 14.647 4.13634L14.6485 4.19549ZM18.086 15.9243H15.9929V14.5305H18.0846L18.086 15.9243ZM18.1955 4.25539C18.1599 4.61366 18.177 4.99214 18.177 5.37025C18.177 5.44999 18.1591 5.50988 18.0678 5.50988H16.141C16.1157 5.51236 16.0904 5.50533 16.0696 5.49004V4.07607H18.0339C18.1053 4.05623 18.1613 4.09591 18.1977 4.17565L18.1955 4.25539Z"
																	fill="#6390C3"
																/>
															</g>
															<defs>
																<clipPath
																	id="clip0_16570_9419"
																>
																	<rect
																		fill="white"
																		height="15"
																		transform="translate(0 2.5)"
																		width="20"
																	/>
																</clipPath>
															</defs>
														</svg>
													</div>
												</div>
												<div>Số video đã upload</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.media_stats
														?.numbers_of_video
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-center justify-start gap-4"
											>
												<img
													alt=""
													class="h-5 w-5"
													src="@/assets/images/icons/upload.png"
												/>
												<div>
													Số dung lượng đã upload
												</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.media_stats
														?.used_size
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="mt-10">
									<div class="font-semibold text-neutral-500">
										Chuyên môn
									</div>
									<div
										class="grid grid-cols-4 items-start md-down:grid-cols-1 mt-2 gap-4"
									>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														width="20"
														height="20"
														viewBox="0 0 20 20"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M15.9789 7.39726L15.3263 8.05058C15.7895 8.99895 16.0421 10.0738 16.0421 11.2118C16.0421 15.216 12.8 18.4615 8.8 18.4615C4.84211 18.4405 1.57895 15.1949 1.57895 11.1907C1.57895 7.18651 4.82105 3.94099 8.82105 3.94099C9.9579 3.94099 11.0105 4.19389 11.9579 4.65753L12.6105 4.00421V3.20337C11.4526 2.65543 10.1684 2.3393 8.82105 2.3393C3.9579 2.3393 0 6.30137 0 11.1697C0 16.0379 3.9579 20 8.82105 20C13.6842 20 17.6421 16.0379 17.6421 11.1697C17.6421 9.82086 17.3263 8.5353 16.7789 7.37619H15.9789V7.39726Z"
															fill="#6366F1"
														/>
														<path
															d="M8.82105 7.20759C9.01053 7.20759 9.2 7.22866 9.38947 7.24974L10.6947 5.9431C10.1053 5.71128 9.49474 5.6059 8.82105 5.6059C5.74737 5.62698 3.26316 8.1138 3.26316 11.1907C3.26316 14.2676 5.74737 16.7756 8.8421 16.7756C11.9158 16.7756 14.4211 14.2676 14.4211 11.1907C14.4211 10.5374 14.2947 9.90516 14.0842 9.31507L12.7789 10.6217C12.8211 10.8114 12.8211 11.0011 12.8211 11.1907C12.8211 13.3825 11.0316 15.1739 8.8421 15.1739C6.63158 15.1739 4.84211 13.3825 4.84211 11.1907C4.84211 8.99895 6.63158 7.20759 8.82105 7.20759Z"
															fill="#6366F1"
														/>
														<path
															d="M19.9579 2.99262C19.8737 2.7608 19.6421 2.63435 19.4105 2.63435H17.3895V0.590095C17.3895 0.358272 17.2421 0.126449 17.0316 0.0421496C16.8 -0.0421496 16.5474 -1.25616e-08 16.3789 0.168599L14.3789 2.17071C14.2737 2.27608 14.2105 2.4236 14.2105 2.5922V4.67861L9.78947 9.08325C9.49474 8.93572 9.1579 8.85142 8.82105 8.85142C7.53684 8.85142 6.50526 9.88409 6.50526 11.1697C6.50526 12.4552 7.53684 13.4879 8.82105 13.4879C10.1053 13.4879 11.1368 12.4552 11.1368 11.1697C11.1368 10.8114 11.0526 10.4953 10.9053 10.2002L15.3263 5.79557H17.4105C17.5579 5.79557 17.7263 5.73235 17.8316 5.62698L19.8316 3.62487C20 3.45627 20.0421 3.20337 19.9579 2.99262Z"
															fill="#6366F1"
														/>
													</svg>
												</div>
												<div>Tổng số mục tiêu</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats
														?.assessment_report_stats
														?.total || 0
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														width="20"
														height="20"
														viewBox="0 0 20 20"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M15.9789 7.39726L15.3263 8.05058C15.7895 8.99895 16.0421 10.0738 16.0421 11.2118C16.0421 15.216 12.8 18.4615 8.8 18.4615C4.84211 18.4405 1.57895 15.1949 1.57895 11.1907C1.57895 7.18651 4.82105 3.94099 8.82105 3.94099C9.9579 3.94099 11.0105 4.19389 11.9579 4.65753L12.6105 4.00421V3.20337C11.4526 2.65543 10.1684 2.3393 8.82105 2.3393C3.9579 2.3393 0 6.30137 0 11.1697C0 16.0379 3.9579 20 8.82105 20C13.6842 20 17.6421 16.0379 17.6421 11.1697C17.6421 9.82086 17.3263 8.5353 16.7789 7.37619H15.9789V7.39726Z"
															fill="#2AA797"
														/>
														<path
															d="M8.82105 7.20759C9.01053 7.20759 9.2 7.22866 9.38947 7.24974L10.6947 5.9431C10.1053 5.71128 9.49474 5.6059 8.82105 5.6059C5.74737 5.62698 3.26316 8.1138 3.26316 11.1907C3.26316 14.2676 5.74737 16.7756 8.8421 16.7756C11.9158 16.7756 14.4211 14.2676 14.4211 11.1907C14.4211 10.5374 14.2947 9.90516 14.0842 9.31507L12.7789 10.6217C12.8211 10.8114 12.8211 11.0011 12.8211 11.1907C12.8211 13.3825 11.0316 15.1739 8.8421 15.1739C6.63158 15.1739 4.84211 13.3825 4.84211 11.1907C4.84211 8.99895 6.63158 7.20759 8.82105 7.20759Z"
															fill="#2AA797"
														/>
														<path
															d="M19.9579 2.99262C19.8737 2.7608 19.6421 2.63435 19.4105 2.63435H17.3895V0.590095C17.3895 0.358272 17.2421 0.126449 17.0316 0.0421496C16.8 -0.0421496 16.5474 -1.25616e-08 16.3789 0.168599L14.3789 2.17071C14.2737 2.27608 14.2105 2.4236 14.2105 2.5922V4.67861L9.78947 9.08325C9.49474 8.93572 9.1579 8.85142 8.82105 8.85142C7.53684 8.85142 6.50526 9.88409 6.50526 11.1697C6.50526 12.4552 7.53684 13.4879 8.82105 13.4879C10.1053 13.4879 11.1368 12.4552 11.1368 11.1697C11.1368 10.8114 11.0526 10.4953 10.9053 10.2002L15.3263 5.79557H17.4105C17.5579 5.79557 17.7263 5.73235 17.8316 5.62698L19.8316 3.62487C20 3.45627 20.0421 3.20337 19.9579 2.99262Z"
															fill="#2AA797"
														/>
													</svg>
												</div>
												<div>Mục tiêu hoàn thành</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats
														?.assessment_report_stats
														?.completed || 0
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														width="20"
														height="20"
														viewBox="0 0 20 20"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M15.9789 7.39726L15.3263 8.05058C15.7895 8.99895 16.0421 10.0738 16.0421 11.2118C16.0421 15.216 12.8 18.4615 8.8 18.4615C4.84211 18.4405 1.57895 15.1949 1.57895 11.1907C1.57895 7.18651 4.82105 3.94099 8.82105 3.94099C9.9579 3.94099 11.0105 4.19389 11.9579 4.65753L12.6105 4.00421V3.20337C11.4526 2.65543 10.1684 2.3393 8.82105 2.3393C3.9579 2.3393 0 6.30137 0 11.1697C0 16.0379 3.9579 20 8.82105 20C13.6842 20 17.6421 16.0379 17.6421 11.1697C17.6421 9.82086 17.3263 8.5353 16.7789 7.37619H15.9789V7.39726Z"
															fill="#F0BB4F"
														/>
														<path
															d="M8.82105 7.20759C9.01053 7.20759 9.2 7.22866 9.38947 7.24974L10.6947 5.9431C10.1053 5.71128 9.49474 5.6059 8.82105 5.6059C5.74737 5.62698 3.26316 8.1138 3.26316 11.1907C3.26316 14.2676 5.74737 16.7756 8.8421 16.7756C11.9158 16.7756 14.4211 14.2676 14.4211 11.1907C14.4211 10.5374 14.2947 9.90516 14.0842 9.31507L12.7789 10.6217C12.8211 10.8114 12.8211 11.0011 12.8211 11.1907C12.8211 13.3825 11.0316 15.1739 8.8421 15.1739C6.63158 15.1739 4.84211 13.3825 4.84211 11.1907C4.84211 8.99895 6.63158 7.20759 8.82105 7.20759Z"
															fill="#F0BB4F"
														/>
														<path
															d="M19.9579 2.99262C19.8737 2.7608 19.6421 2.63435 19.4105 2.63435H17.3895V0.590095C17.3895 0.358272 17.2421 0.126449 17.0316 0.0421496C16.8 -0.0421496 16.5474 -1.25616e-08 16.3789 0.168599L14.3789 2.17071C14.2737 2.27608 14.2105 2.4236 14.2105 2.5922V4.67861L9.78947 9.08325C9.49474 8.93572 9.1579 8.85142 8.82105 8.85142C7.53684 8.85142 6.50526 9.88409 6.50526 11.1697C6.50526 12.4552 7.53684 13.4879 8.82105 13.4879C10.1053 13.4879 11.1368 12.4552 11.1368 11.1697C11.1368 10.8114 11.0526 10.4953 10.9053 10.2002L15.3263 5.79557H17.4105C17.5579 5.79557 17.7263 5.73235 17.8316 5.62698L19.8316 3.62487C20 3.45627 20.0421 3.20337 19.9579 2.99262Z"
															fill="#F0BB4F"
														/>
													</svg>
												</div>
												<div>Mục tiêu lặp lại</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats
														?.assessment_report_stats
														?.continued || 0
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														width="20"
														height="20"
														viewBox="0 0 20 20"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M15.9789 7.39726L15.3263 8.05058C15.7895 8.99895 16.0421 10.0738 16.0421 11.2118C16.0421 15.216 12.8 18.4615 8.8 18.4615C4.84211 18.4405 1.57895 15.1949 1.57895 11.1907C1.57895 7.18651 4.82105 3.94099 8.82105 3.94099C9.9579 3.94099 11.0105 4.19389 11.9579 4.65753L12.6105 4.00421V3.20337C11.4526 2.65543 10.1684 2.3393 8.82105 2.3393C3.9579 2.3393 0 6.30137 0 11.1697C0 16.0379 3.9579 20 8.82105 20C13.6842 20 17.6421 16.0379 17.6421 11.1697C17.6421 9.82086 17.3263 8.5353 16.7789 7.37619H15.9789V7.39726Z"
															fill="#E37056"
														/>
														<path
															d="M8.82105 7.20759C9.01053 7.20759 9.2 7.22866 9.38947 7.24974L10.6947 5.9431C10.1053 5.71128 9.49474 5.6059 8.82105 5.6059C5.74737 5.62698 3.26316 8.1138 3.26316 11.1907C3.26316 14.2676 5.74737 16.7756 8.8421 16.7756C11.9158 16.7756 14.4211 14.2676 14.4211 11.1907C14.4211 10.5374 14.2947 9.90516 14.0842 9.31507L12.7789 10.6217C12.8211 10.8114 12.8211 11.0011 12.8211 11.1907C12.8211 13.3825 11.0316 15.1739 8.8421 15.1739C6.63158 15.1739 4.84211 13.3825 4.84211 11.1907C4.84211 8.99895 6.63158 7.20759 8.82105 7.20759Z"
															fill="#E37056"
														/>
														<path
															d="M19.9579 2.99262C19.8737 2.7608 19.6421 2.63435 19.4105 2.63435H17.3895V0.590095C17.3895 0.358272 17.2421 0.126449 17.0316 0.0421496C16.8 -0.0421496 16.5474 -1.25616e-08 16.3789 0.168599L14.3789 2.17071C14.2737 2.27608 14.2105 2.4236 14.2105 2.5922V4.67861L9.78947 9.08325C9.49474 8.93572 9.1579 8.85142 8.82105 8.85142C7.53684 8.85142 6.50526 9.88409 6.50526 11.1697C6.50526 12.4552 7.53684 13.4879 8.82105 13.4879C10.1053 13.4879 11.1368 12.4552 11.1368 11.1697C11.1368 10.8114 11.0526 10.4953 10.9053 10.2002L15.3263 5.79557H17.4105C17.5579 5.79557 17.7263 5.73235 17.8316 5.62698L19.8316 3.62487C20 3.45627 20.0421 3.20337 19.9579 2.99262Z"
															fill="#E37056"
														/>
													</svg>
												</div>
												<div>Mục tiêu tạm dừng</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats
														?.assessment_report_stats
														?.stopped || 0
												}}
											</div>
										</div>
									</div>
									<div
										class="grid grid-cols-2 items-start md-down:grid-cols-1 mt-4 gap-4"
									>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M8.75 17.5C8.75 17.5 7.5 17.5 7.5 16.25C7.5 15 8.75 11.25 13.75 11.25C18.75 11.25 20 15 20 16.25C20 17.5 18.75 17.5 18.75 17.5H8.75Z"
															fill="#2AA797"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M13.75 10C15.8211 10 17.5 8.32107 17.5 6.25C17.5 4.17893 15.8211 2.5 13.75 2.5C11.6789 2.5 10 4.17893 10 6.25C10 8.32107 11.6789 10 13.75 10Z"
															fill="#2AA797"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M6.52045 17.5C6.34445 17.1449 6.25 16.7239 6.25 16.25C6.25 14.5557 7.09882 12.8132 8.66991 11.6C7.98262 11.3801 7.18137 11.25 6.25 11.25C1.25 11.25 0 15 0 16.25C0 17.5 1.25 17.5 1.25 17.5H6.52045Z"
															fill="#2AA797"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M5.625 10C7.35089 10 8.75 8.60089 8.75 6.875C8.75 5.14911 7.35089 3.75 5.625 3.75C3.89911 3.75 2.5 5.14911 2.5 6.875C2.5 8.60089 3.89911 10 5.625 10Z"
															fill="#2AA797"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>
													Số HS can thiệp cá nhân
												</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.student_stats
														?.numbers_of_student
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-center justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M15.4163 13.3327C17.9476 13.3327 19.9997 11.2807 19.9997 8.74935C19.9997 6.21804 17.9476 4.16602 15.4163 4.16602C12.885 4.16602 10.833 6.21804 10.833 8.74935C10.833 11.2807 12.885 13.3327 15.4163 13.3327ZM12.9336 8.36742C12.6172 8.36742 12.3607 8.62392 12.3607 8.94033C12.3607 9.25675 12.6172 9.51325 12.9336 9.51325H17.517C17.8334 9.51325 18.0899 9.25675 18.0899 8.94033C18.0899 8.62392 17.8334 8.36742 17.517 8.36742H12.9336Z"
															fill="#E37056"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M10.0075 9.03836C9.3432 9.63619 8.46409 10 7.5 10C5.42893 10 3.75 8.32107 3.75 6.25C3.75 4.17893 5.42893 2.5 7.5 2.5C9.28104 2.5 10.7721 3.74162 11.1548 5.40651C10.4314 6.32728 10 7.48826 10 8.75C10 8.84673 10.0025 8.94288 10.0075 9.03836ZM10.879 11.7091C9.95946 11.4238 8.84561 11.25 7.5 11.25C1.25 11.25 0 15 0 16.25C0 17.5 1.25 17.5 1.25 17.5H13.75C13.75 17.5 15 17.5 15 16.25C15 15.7655 14.8122 14.9054 14.2182 14.0336C12.8256 13.7191 11.6363 12.868 10.879 11.7091Z"
															fill="#E37056"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Số HS tạm dừng</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.student_stats
														?.numbers_of_disabled_assignment
												}}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="mt-10">
								<div
									class="bg-white shadow border-sm p-6 rounded-lg"
								>
									<div
										class="text-neutral-600 font-semibold text-lg"
									>
										Kết quả học tập
									</div>
									<div
										class="relative mt-6 flex items-center"
									>
										<div class="h-full mr-10 pt-6">
											<div
												class="flex flex-col items-start justify-between"
												style="height: 200px"
											>
												<div
													class="w-full rounded-full text-center text-white text-sm font-semibold py-1 px-4 whitespace-nowrap"
													style="background: #2aa797"
												>
													Đạt > 75%
												</div>
												<div
													class="w-full rounded-full text-center text-white text-sm font-semibold py-1 px-4 whitespace-nowrap"
													style="background: #65a30d"
												>
													Đạt 55-75%
												</div>
												<div
													class="w-full rounded-full text-center text-white text-sm font-semibold py-1 px-4 whitespace-nowrap"
													style="background: #f59e0b"
												>
													Đạt 25-55%
												</div>
												<div
													class="w-full rounded-full text-center text-white text-sm font-semibold py-1 px-4 whitespace-nowrap"
													style="background: #f87171"
												>
													Đạt &lt; 25%
												</div>
											</div>

											<div
												class="text-neutral-500 text-sm mt-8 font-medium whitespace-nowrap"
											>
												Số học sinh (%)
											</div>
										</div>
										<div
											class="w-full grid grid-cols-10 pt-6 relative"
										>
											<div
												class="absolute l-0 pt-8 w-full flex flex-col items-start justify-between"
												style="height: 216px"
											>
												<div
													:style="{
														width:
															dataStats
																?.assessment_stats
																?.assessment_more_than_seventy_percent +
															'%',
													}"
													style="
														height: 15px;
														background: #2aa797;
														border-radius: 0 99px
															99px 0;
													"
												></div>
												<div
													:style="{
														width:
															dataStats
																?.assessment_stats
																?.assessment_less_than_seventy_percent +
															'%',
													}"
													style="
														height: 15px;
														background: #65a30d;
														border-radius: 0 99px
															99px 0;
													"
												></div>
												<div
													:style="{
														width:
															dataStats
																?.assessment_stats
																?.assessment_less_than_sixty_percent +
															'%',
													}"
													style="
														height: 15px;
														background: #f59e0b;
														border-radius: 0 99px
															99px 0;
													"
												></div>
												<div
													:style="{
														width:
															dataStats
																?.assessment_stats
																?.assessment_less_than_fifty_percent +
															'%',
													}"
													style="
														height: 15px;
														background: #f87171;
														border-radius: 0 99px
															99px 0;
													"
												></div>
											</div>
											<div v-for="i in 10" :key="i">
												<div
													:class="{
														'border-r-0': i !== 10,
													}"
													class="border border-t-0 border-b-0 border-l border-neutral-200"
													style="height: 200px"
												></div>
												<div
													class="text-neutral-500 text-sm mt-8 font-semibold float-right -mr-2"
												>
													{{ i * 10 }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="mt-10">
								<Analytics
									:assessments_map="
										dataStats?.assessments_map
									"
									:students="dataStats?.students"
								/>
							</div>
						</div>
					</div>
					<div
						v-if="tab === routerName.RECORD_EMPLOYEE_STATS_DAYCARE"
					>
						<div v-if="!notAnalytics" class="w-full">
							<div>
								<div class="relative mt-16">
									<div
										aria-hidden="true"
										class="absolute inset-0 flex items-center"
									>
										<div
											class="w-full border-t border-neutral-300"
										/>
									</div>
									<div class="relative flex justify-center">
										<div
											class="bg-body px-2 text-neutral-600 font-semibold text-2xl whitespace-nowrap flex flex-nowrap items-center justify-center gap-6"
										>
											<div
												v-if="
													date.month > 0 ||
													date.year > 2023
												"
												class="cursor-pointer"
												@click="prevDay"
											>
												<svg
													fill="none"
													height="12"
													viewBox="0 0 8 12"
													width="8"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M6.5 1L1.5 6L6.5 11"
														stroke="#48566A"
														stroke-linecap="round"
														stroke-linejoin="round"
														stroke-width="2"
													/>
												</svg>
											</div>
											<VueDatepicker
												v-model="date"
												:max-date="new Date()"
												:min-date="new Date(2023, 1, 0)"
												auto-apply
												class="input-date-dashboard"
												format="MM/yyyy"
												month-picker
												placeholder="Chọn tháng"
												uid="filter-by-date"
											>
												<template #trigger>
													<div
														v-if="date"
														class="flex items-center gap-2.5 cursor-pointer"
													>
														<svg
															fill="none"
															height="16"
															viewBox="0 0 17 16"
															width="17"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																clip-rule="evenodd"
																d="M4.5 0.5C4.5 0.223858 4.27614 0 4 0C3.72386 0 3.5 0.223858 3.5 0.5V1H2.5C1.39543 1 0.5 1.89543 0.5 3V4H16.5V3C16.5 1.89543 15.6046 1 14.5 1H13.5V0.5C13.5 0.223858 13.2761 0 13 0C12.7239 0 12.5 0.223858 12.5 0.5V1H4.5V0.5ZM16.5 14V5H0.5V14C0.5 15.1046 1.39543 16 2.5 16H14.5C15.6046 16 16.5 15.1046 16.5 14ZM10 7C9.72386 7 9.5 7.22386 9.5 7.5V8.5C9.5 8.77614 9.72386 9 10 9H11C11.2761 9 11.5 8.77614 11.5 8.5V7.5C11.5 7.22386 11.2761 7 11 7H10ZM13 7C12.7239 7 12.5 7.22386 12.5 7.5V8.5C12.5 8.77614 12.7239 9 13 9H14C14.2761 9 14.5 8.77614 14.5 8.5V7.5C14.5 7.22386 14.2761 7 14 7H13ZM2.5 10.5C2.5 10.2239 2.72386 10 3 10H4C4.27614 10 4.5 10.2239 4.5 10.5V11.5C4.5 11.7761 4.27614 12 4 12H3C2.72386 12 2.5 11.7761 2.5 11.5V10.5ZM6 10C5.72386 10 5.5 10.2239 5.5 10.5V11.5C5.5 11.7761 5.72386 12 6 12H7C7.27614 12 7.5 11.7761 7.5 11.5V10.5C7.5 10.2239 7.27614 10 7 10H6Z"
																fill="#48566A"
																fill-rule="evenodd"
															/>
														</svg>
														<span
															>Tháng
															{{
																dateTitle
															}}</span
														>
													</div>
												</template>
											</VueDatepicker>
											<div
												v-if="
													date.month <
														new Date().getMonth() ||
													date.year <
														new Date().getFullYear()
												"
												class="cursor-pointer"
												@click="nextDay"
											>
												<svg
													fill="none"
													height="12"
													viewBox="0 0 8 12"
													width="8"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M1.5 11L6.5 6L1.5 1"
														stroke="#48566A"
														stroke-linecap="round"
														stroke-linejoin="round"
														stroke-width="2"
													/>
												</svg>
											</div>
										</div>
									</div>
								</div>
								<div class="mt-10">
									<div class="font-semibold text-neutral-500">
										Chuyên cần theo ngày
									</div>
									<div
										class="grid grid-cols-3 items-start md-down:grid-cols-1 mt-2 gap-4"
									>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 4.375C10 4.02982 9.72018 3.75 9.375 3.75C9.02982 3.75 8.75 4.02982 8.75 4.375V11.25C8.75 11.4743 8.87018 11.6814 9.06491 11.7927L13.4399 14.2927C13.7396 14.4639 14.1214 14.3598 14.2927 14.0601C14.4639 13.7604 14.3598 13.3786 14.0601 13.2073L10 10.8873V4.375Z"
															fill="#6366F1"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>
													Số ngày đã dạy / dự kiến
												</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.session_stats
														?.total_created_days
												}}/
												{{
													dataStats?.session_stats
														?.total_scheduled_days
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 24 20"
														width="24"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z"
															fill="#F1A267"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z"
															fill="#F1A267"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Số ngày học phát sinh</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.session_stats
														?.total_unscheduled_days
												}}
											</div>
										</div>
										<div
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 24 20"
														width="24"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z"
															fill="#E68D7B"
															fill-rule="evenodd"
														/>
														<path
															clip-rule="evenodd"
															d="M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z"
															fill="#E68D7B"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>Số ngày nghỉ</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStats?.session_stats
														?.total_cancelled_days
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="mt-10">
									<div class="font-semibold text-neutral-500">
										Tiến độ hoàn thành báo cáo bán trú (hoàn
										thành/tổng số)
									</div>
									<div
										class="grid grid-cols-3 items-start md-down:grid-cols-1 mt-2 gap-4"
									>
										<div
											v-for="day_care_class in dataStatsDayCare.day_care_class"
											:key="day_care_class.id"
											class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
										>
											<div
												class="flex items-start justify-start gap-4"
											>
												<div>
													<svg
														fill="none"
														height="20"
														viewBox="0 0 20 20"
														width="20"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															clip-rule="evenodd"
															d="M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z"
															fill="#41BEAD"
															fill-rule="evenodd"
														/>
													</svg>
												</div>
												<div>
													BC lớp
													{{ day_care_class.name }}
												</div>
											</div>
											<div
												class="text-4xl font-bold mt-4 text-neutral-600"
											>
												{{
													dataStatsDayCare
														?.report_stats[
														day_care_class.id
													]?.completed_report_count ||
													0
												}}/{{
													dataStatsDayCare
														?.report_stats[
														day_care_class.id
													]?.total_report || 0
												}}
											</div>
										</div>
									</div>
								</div>
								<div class="mt-10">
									<div class="font-semibold text-neutral-500">
										Lớp bán trú đang dạy
									</div>
									<div
										v-for="day_care_class in dataStatsDayCare.day_care_class"
										:key="day_care_class.id"
										class="mt-6"
									>
										<div
											class="flex items-center justify-between mb-1"
										>
											<div
												class="font-semibold flex gap-2 items-center text-neutral-500"
											>
												<svg
													fill="none"
													height="20"
													viewBox="0 0 20 20"
													width="20"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M5.99666 20C6.21401 19.9999 6.4291 19.9559 6.62903 19.8706C6.82897 19.7854 7.00964 19.6607 7.16022 19.5039C7.3108 19.3472 7.42819 19.1617 7.50536 18.9585C7.58253 18.7553 7.61788 18.5386 7.60931 18.3214L7.33907 9.88249L8.5167 9.17284C8.8171 8.99077 9.06357 8.73196 9.23077 8.42305C9.39797 8.11413 9.47987 7.76625 9.46803 7.41518L9.23294 0.617447C9.22724 0.453467 9.15807 0.298112 9.04002 0.184158C8.92197 0.0702041 8.76427 0.00656322 8.60019 0.00666215C8.43688 0.00828381 8.28053 0.0729825 8.16383 0.187227C8.04713 0.301471 7.97912 0.456412 7.97402 0.619645L7.80924 4.85559C7.80781 4.98185 7.76112 5.1034 7.67766 5.19815C7.5942 5.2929 7.47951 5.35455 7.35445 5.37191C7.28497 5.37951 7.21467 5.37268 7.14795 5.35184C7.08124 5.33101 7.01954 5.29662 6.96674 5.25082C6.91393 5.20503 6.87116 5.14883 6.84109 5.08573C6.81102 5.02264 6.79431 4.95401 6.792 4.88416L6.62722 0.643812C6.62335 0.498377 6.57147 0.358308 6.47966 0.245442C6.38786 0.132576 6.26129 0.0532551 6.1197 0.0198446C6.03534 0.00562738 5.94919 0.00562738 5.86484 0.0198446C5.72324 0.0532551 5.59667 0.132576 5.50487 0.245442C5.41306 0.358308 5.36118 0.498377 5.35731 0.643812L5.19253 4.88416C5.19022 4.95401 5.17351 5.02264 5.14344 5.08573C5.11337 5.14883 5.0706 5.20503 5.01779 5.25082C4.96499 5.29662 4.9033 5.33101 4.83658 5.35184C4.76986 5.37268 4.69956 5.37951 4.63008 5.37191C4.50502 5.35455 4.39033 5.2929 4.30687 5.19815C4.22341 5.1034 4.17672 4.98185 4.17529 4.85559L4.00392 0.619645C3.99875 0.45336 3.92829 0.295802 3.80781 0.181078C3.68733 0.0663532 3.52652 0.00369344 3.36018 0.00666215C3.1961 0.00656322 3.0384 0.0702041 2.92034 0.184158C2.80229 0.298112 2.73312 0.453467 2.72742 0.617447L2.50112 7.41738C2.48929 7.76844 2.57118 8.11632 2.73838 8.42524C2.90558 8.73416 3.15206 8.99296 3.45245 9.17503L4.65205 9.89567L4.38181 18.3214C4.37323 18.5388 4.40865 18.7557 4.48596 18.959C4.56326 19.1623 4.68085 19.3479 4.83166 19.5047C4.98248 19.6615 5.16341 19.7862 5.36361 19.8713C5.5638 19.9564 5.77913 20.0002 5.99666 20Z"
														fill="#3B82F6"
													/>
													<path
														d="M17.8125 8.24569C18.1252 7.6708 18.287 7.026 18.2827 6.37159C18.2673 4.22065 17.8784 0.0220559 14.7872 8.5179e-05C11.6959 -0.0218855 11.307 4.21187 11.2916 6.37159C11.2866 7.0258 11.4477 7.6706 11.7596 8.24569C12.0901 8.85577 12.5779 9.3663 13.1723 9.72431L13.4623 9.90008L13.1943 18.3214C13.1863 18.5355 13.2216 18.7489 13.298 18.9489C13.3744 19.149 13.4904 19.3316 13.639 19.4858C13.7876 19.64 13.9658 19.7627 14.1629 19.8465C14.3599 19.9303 14.5719 19.9735 14.7861 19.9735C15.0002 19.9735 15.2122 19.9303 15.4093 19.8465C15.6063 19.7627 15.7845 19.64 15.9331 19.4858C16.0817 19.3316 16.1977 19.149 16.2741 18.9489C16.3505 18.7489 16.3858 18.5355 16.3778 18.3214L16.1032 9.89568L16.3932 9.71992C16.9894 9.36403 17.4795 8.855 17.8125 8.24569Z"
														fill="#3B82F6"
													/>
												</svg>
												{{ day_care_class?.name }}
											</div>
											<div
												class="text-neutral-400 cursor-pointer"
												@click="
													$router.push(
														`/daycare-class/${day_care_class?.id}`
													)
												"
											>
												Xem thêm
											</div>
										</div>
										<div
											class="grid grid-cols-3 items-start md-down:grid-cols-1 mt-2 gap-4"
										>
											<div
												class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
											>
												<div
													class="flex items-start justify-start gap-4"
												>
													<div>
														<svg
															fill="none"
															height="20"
															viewBox="0 0 20 20"
															width="20"
															xmlns="http://www.w3.org/2000/svg"
														>
															<g
																clip-path="url(#clip0_24861_12969)"
															>
																<path
																	d="M7 9.75C6.31 9.75 5.75 10.31 5.75 11C5.75 11.69 6.31 12.25 7 12.25C7.69 12.25 8.25 11.69 8.25 11C8.25 10.31 7.69 9.75 7 9.75ZM13 9.75C12.31 9.75 11.75 10.31 11.75 11C11.75 11.69 12.31 12.25 13 12.25C13.69 12.25 14.25 11.69 14.25 11C14.25 10.31 13.69 9.75 13 9.75ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 9.71 2.02 9.42 2.05 9.14C4.41 8.09 6.28 6.16 7.26 3.77C9.07 6.33 12.05 8 15.42 8C16.2 8 16.95 7.91 17.67 7.74C17.88 8.45 18 9.21 18 10C18 14.41 14.41 18 10 18Z"
																	fill="#2AA797"
																/>
																<path
																	d="M8 13.9895C8 13.9895 9.86667 18.4895 12 13.9895H8Z"
																	fill="#2AA797"
																/>
															</g>
															<defs>
																<clipPath
																	id="clip0_24861_12969"
																>
																	<rect
																		fill="white"
																		height="20"
																		width="20"
																	/>
																</clipPath>
															</defs>
														</svg>
													</div>
													<div>Học sinh</div>
												</div>
												<div
													class="text-4xl font-bold mt-4 text-neutral-600"
												>
													{{
														day_care_class?.number_of_student
													}}
												</div>
											</div>
											<div
												class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
											>
												<div
													class="flex items-start justify-start gap-4"
												>
													<div>
														<svg
															fill="none"
															height="20"
															viewBox="0 0 21 20"
															width="21"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M17.5019 15.4634C16.6131 14.0316 14.6609 12.5 10.6667 12.5C6.67251 12.5 4.72038 14.0316 3.83154 15.4634C5.43501 17.4668 7.90102 18.75 10.6667 18.75C13.4324 18.75 15.8984 17.4668 17.5019 15.4634Z"
																fill="#86A8D0"
															/>
															<path
																clip-rule="evenodd"
																d="M10.6665 11.25C12.7376 11.25 14.4165 9.57107 14.4165 7.5C14.4165 5.42893 12.7376 3.75 10.6665 3.75C8.59544 3.75 6.9165 5.42893 6.9165 7.5C6.9165 9.57107 8.59544 11.25 10.6665 11.25Z"
																fill="#86A8D0"
																fill-rule="evenodd"
															/>
															<path
																clip-rule="evenodd"
																d="M10.6665 1.25C5.83401 1.25 1.9165 5.16751 1.9165 10C1.9165 14.8325 5.83401 18.75 10.6665 18.75C15.499 18.75 19.4165 14.8325 19.4165 10C19.4165 5.16751 15.499 1.25 10.6665 1.25ZM0.666504 10C0.666504 4.47715 5.14366 0 10.6665 0C16.1894 0 20.6665 4.47715 20.6665 10C20.6665 15.5228 16.1894 20 10.6665 20C5.14366 20 0.666504 15.5228 0.666504 10Z"
																fill="#86A8D0"
																fill-rule="evenodd"
															/>
														</svg>
													</div>
													<div>Giáo viên bán trú</div>
												</div>
												<div
													class="text-4xl font-bold mt-4 text-neutral-600"
												>
													{{
														day_care_class?.number_of_staff
													}}
												</div>
											</div>
											<div
												class="w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
											>
												<div
													class="flex items-start justify-start gap-4"
												>
													<div>
														<svg
															fill="none"
															height="20"
															viewBox="0 0 21 20"
															width="21"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																clip-rule="evenodd"
																d="M5.3335 0.625C5.3335 0.279822 5.05367 0 4.7085 0C4.36332 0 4.0835 0.279822 4.0835 0.625V1.25H2.8335C1.45278 1.25 0.333496 2.36929 0.333496 3.75V5H20.3335V3.75C20.3335 2.36929 19.2142 1.25 17.8335 1.25H16.5835V0.625C16.5835 0.279822 16.3037 0 15.9585 0C15.6133 0 15.3335 0.279822 15.3335 0.625V1.25H5.3335V0.625ZM20.3335 17.5V6.25H0.333496V17.5C0.333496 18.8807 1.45279 20 2.8335 20H17.8335C19.2142 20 20.3335 18.8807 20.3335 17.5ZM12.2085 8.75C11.8633 8.75 11.5835 9.02982 11.5835 9.375V10.625C11.5835 10.9702 11.8633 11.25 12.2085 11.25H13.4585C13.8037 11.25 14.0835 10.9702 14.0835 10.625V9.375C14.0835 9.02982 13.8037 8.75 13.4585 8.75H12.2085ZM15.9585 8.75C15.6133 8.75 15.3335 9.02982 15.3335 9.375V10.625C15.3335 10.9702 15.6133 11.25 15.9585 11.25H17.2085C17.5537 11.25 17.8335 10.9702 17.8335 10.625V9.375C17.8335 9.02982 17.5537 8.75 17.2085 8.75H15.9585ZM2.8335 13.125C2.8335 12.7798 3.11332 12.5 3.4585 12.5H4.7085C5.05367 12.5 5.3335 12.7798 5.3335 13.125V14.375C5.3335 14.7202 5.05367 15 4.7085 15H3.4585C3.11332 15 2.8335 14.7202 2.8335 14.375V13.125ZM7.2085 12.5C6.86332 12.5 6.5835 12.7798 6.5835 13.125V14.375C6.5835 14.7202 6.86332 15 7.2085 15H8.4585C8.80367 15 9.0835 14.7202 9.0835 14.375V13.125C9.0835 12.7798 8.80367 12.5 8.4585 12.5H7.2085Z"
																fill="#F0BB4F"
																fill-rule="evenodd"
															/>
														</svg>
													</div>
													<div>Ngày học</div>
												</div>
												<div
													class="text-4xl font-bold mt-4 text-neutral-600"
												>
													{{
														dayOfWeekDisplay(
															day_care_class.class_day_slots
														)
													}}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="tab === routerName.RECORD_EMPLOYEE_DETAIL_INFO"
						class="flex items-center"
					>
						<div class="w-full max-w-lg">
							<InformationTable
								v-if="staff"
								:staff="staff"
								@submit="updateStaff"
								@updated="updatedAvatar"
							/>
							<div
								v-if="
									!notAnalytics &&
									setup?.store?.state?.profile?.staff?.id !==
										staff?.id &&
									isAdmin
								"
								class="font-semibold text-yellow-700 underline text-sm mt-6 text-right cursor-pointer"
								@click="
									openModel(ModalType.CHANGE_STATUS, false)
								"
							>
								Khoá tài khoản?
							</div>
						</div>
						<div
							v-if="notAnalytics"
							class="w-7/12 flex items-center justify-center xl-down:w-full p-6"
						>
							<div
								class="flex items-center justify-center flex-col"
							>
								<DaIcon
									class="h-16 w-16 text-neutral-200"
									name="das--user-close"
								/>
								<div
									class="text-neutral-600 font-semibold mt-1"
								>
									Tài khoản đang khoá
								</div>
								<div
									class="text-sm text-neutral-500 mt-1 text-center"
								>
									Bạn hãy kich hoạt tài khoản cho trị liệu
									viên để xem thống kê nhé
								</div>
								<button
									class="button-p w-fit mt-6"
									type="button"
									@click="openModel(ModalType.CHANGE_STATUS)"
								>
									Kích hoạt tài khoản
								</button>
							</div>
						</div>
					</div>
					<div v-if="tab === routerName.RECORD_EMPLOYEE_FILE">
						<StaffFile v-model:data="staff" />
					</div>
				</div>
			</div>
		</div>

		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script>
import { Options, setup, Vue } from 'vue-class-component';
import { _MODAL_TYPE, _ROUTER_NAME } from '@/enums';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import ChangeStatus from '@/views/record/employeeDetail/features/changeStatus/ChangeStatus.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import LeaveReport from '@/views/record/employeeDetail/features/leaveReport/LeaveReport.vue';
import InformationTable from '@/views/record/employeeDetail/features/informationTable/InformationTable.vue';
import Analytics from '@/views/record/employeeDetail/features/analytics/Analytics.vue';
import { useGetEmployee } from '@/views/record/employeeDetail/services/getEmployee';
import { staff } from '@/views/record/employeeDetail/@types/staff.interface';
import { useUpdateStaff } from '@/views/record/employeeDetail/services/updateStaff';
import { Watch } from 'vue-property-decorator';
import { useCloseStaff } from '@/views/record/employeeDetail/services/closeStaff';
import { useActiveStaff } from '@/views/record/employeeDetail/services/activeStaff';
// @ts-ignore
import Popper from 'vue3-popper';
import { useStore } from 'vuex';
import Loading from '@/components/common/Loading.vue';
import ChangeStatusAssignedDaycareClass from '@/views/record/employeeDetail/features/changeStatus/ChangeStatusAssignedDaycareClass.vue';
import ChangeStatusAssigned from '@/views/record/employeeDetail/features/changeStatus/ChangeStatusAssigned.vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import dayjs from 'dayjs';
import { $api } from '@/services';
import StaffFile from './StaffFile.vue';
import { isLitePackage } from '@/helper/packageTier';
import store from '@/store';

@Options({
	name: '',
	components: {
		ChangeStatusAssigned,
		ChangeStatusAssignedDaycareClass,
		Loading,
		Analytics,
		InformationTable,
		LeaveReport,
		DaModalFrame,
		ChangeStatus,
		DaIcon,
		Popper,
		Multiselect,
		StaffFile,
	},
})
export default class EmployeeDetail extends Vue {
	//----------------------- 🤍 Data 🤍 -----------------------//
	modalIsOpen = false;
	modalType = 'LEAVE_REPORT';
	notAnalytics = true;
	activeMode = true;

	staff = {
		full_name: '',
		id: 0,
		name: '',
		phone_number: '',
		role: '',
		state: '',
		email: '',
		has_staff_day_care_membership: false,
		has_assignment: false,
	};

	tab = this.routerName.RECORD_EMPLOYEE_DETAIL_INFO;

	errorAssignedDayClasses = [];
	errorAssigned = [];

	isLoading = true;

	date = {
		month: new Date().getMonth(),
		year: new Date().getFullYear(),
	};

	dataStatsDayCare = {
		class_session_stats: {
			cancelled_count: 0,
			created_count: 0,
			scheduled_count: 0,
			unscheduled_count: 0,
		},
		day_care_class: [],
		report_stats: {},
	};

	dataStats = {
		assessment_stats: {
			assessment_less_than_fifty_percent: 0,
			assessment_less_than_seventy_percent: 0,
			assessment_less_than_sixty_percent: 0,
			assessment_more_than_seventy_percent: 0,
		},
		assessments_map: [],
		lesson_report_stats: {
			numbers_of_completed_lesson_report: 0,
			numbers_of_lesson_report: 0,
		},
		media_stats: {
			numbers_of_image: 0,
			numbers_of_video: 0,
		},
		monthly_report_stats: {
			numbers_of_completed_monthly_report: 0,
			numbers_of_monthly_report: 0,
		},
		session_stats: {
			total_created_hours: 0,
			total_scheduled_hours: 0,
			total_unscheduled_hours: 0,
			total_cancelled_hours: 0,
			numbers_of_cancelled_session: 0,
			numbers_of_created_session: 0,
			numbers_of_future_sessions: 0,
			numbers_of_scheduled_session: 0,
			numbers_of_unscheduled_session: 0,
			total_created_days: 0,
			total_scheduled_days: 0,
			total_unscheduled_days: 0,
			total_cancelled_days: 0,
			total_cancelled_by_staff_days: 0,
			total_cancelled_by_student_days: 0,
			total_cancelled_by_staff_hours: 0,
			total_cancelled_by_student_hours: 0,
		},
		student_stats: {
			numbers_of_disabled_assignment: 0,
			numbers_of_student: 0,
		},
		weekly_report_stats: {
			numbers_of_completed_weekly_report: 0,
			numbers_of_weekly_report: 0,
		},
		plan_stats: {
			numbers_of_done_plan: 0,
			numbers_of_plan: 0,
		},
		students: [],
	};
	//----------------------- 🤍 Setup 🤍 -----------------------//
	setup = setup(() => {
		const store = useStore();
		const { error, loading, getEmployee } = useGetEmployee();
		const { updateStaff__error, updateStaff } = useUpdateStaff();
		const { closeStaff__error, closeStaff } = useCloseStaff();
		const { activeStaff__error, activeStaff } = useActiveStaff();

		return {
			error,
			updateStaff__error,
			closeStaff__error,
			activeStaff__error,
			loading,
			closeStaff,
			updateStaff,
			getEmployee,
			activeStaff,
			store,
		};
	});

	get dateTitle() {
		return dayjs(new Date(this.date.year, this.date.month, 1)).format(
			'MM/YYYY'
		);
	}

	get datePayload() {
		return dayjs(new Date(this.date.year, this.date.month, 1)).format(
			'YYYY-MM-DD'
		);
	}

	get id() {
		return this.$route.params.id ? this.$route.params.id + '' : '';
	}

	//----------------------- 🤍 Getters 🤍 -----------------------//
	get routerName() {
		return _ROUTER_NAME;
	}

	get ModalType() {
		return _MODAL_TYPE;
	}

	get store() {
		return this.setup.store;
	}

	get isAdmin() {
		return this.setup.store.getters.isAdmin;
	}

	get centerState() {
		return this.setup.store.state.profile.center_state;
	}

	get isLitePackage() {
		return isLitePackage(store.state.profile);
	}
	//----------------------- 🤍 Mounted 🤍 -----------------------//
	created() {
		this.fetchStaff();

		if (this.$route.query.tab) {
			this.tab = this.$route.query.tab;
		} else {
			if (this.tab === this.routerName.RECORD_EMPLOYEE_STATS_DAYCARE) {
				this.fetchStaffStatsDayCare();
			} else if (this.tab === this.routerName.RECORD_EMPLOYEE_STATS) {
				this.fetchStaffStats();
				this.fetchStaffStatsDayCare();
			} else {
				this.fetchStaffStats();
			}
		}
	}

	@Watch('date', { deep: true })
	onDateChange(value) {
		if (value) {
			if (this.tab === this.routerName.RECORD_EMPLOYEE_STATS_DAYCARE) {
				this.fetchStaffStatsDayCare();
			} else if (this.tab === this.routerName.RECORD_EMPLOYEE_STATS) {
				this.fetchStaffStats();
				this.fetchStaffStatsDayCare();
			} else {
				this.fetchStaffStats();
			}
		}
	}

	@Watch('tab', { deep: true })
	onTabChange(value) {
		console.log(value);
		if (value === this.routerName.RECORD_EMPLOYEE_STATS_DAYCARE) {
			this.fetchStaffStatsDayCare();
		} else if (value === this.routerName.RECORD_EMPLOYEE_STATS) {
			this.fetchStaffStats();
			this.fetchStaffStatsDayCare();
		}
	}

	//----------------------- 🤍 Watch 🤍 -----------------------//
	@Watch('staff', { immediate: true, deep: true })
	onStaffChange(value) {
		this.notAnalytics = value.state !== 'active';
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	openModel(type, activeMode = true) {
		this.activeMode = activeMode;
		this.modalIsOpen = true;
		this.modalType = type;
	}

	async fetchStaff() {
		const staff = await this.setup.getEmployee(this.id);
		this.staff = staff.data;
		if (
			(!this.staff.has_assignment &&
				this.tab === _ROUTER_NAME.RECORD_EMPLOYEE_STATS) ||
			this.staff.state !== 'active'
		) {
			this.tab = _ROUTER_NAME.RECORD_EMPLOYEE_DETAIL_INFO;
		}
		this.isLoading = false;
	}

	updatedAvatar() {
		this.fetchStaff();
	}

	async updateStaff(staff) {
		const data = await this.setup.updateStaff(this.id, {
			full_name: staff.full_name,
			name: staff.name,
			phone_number: staff.phone_number,
			emergency_phone_number: staff.emergency_phone_number,
			date_of_birth: staff.date_of_birth,
			role: staff.role,
		});
		if (data && data?.data) {
			this.staff = data?.data;
			await this.store.dispatch('setAlertMessage', {
				message: 'Cập nhật thông tin thành công',
			});
		}
	}

	async closeStaff() {
		const data = await this.setup.closeStaff(this.id);
		const { assigned_day_care_classes, assigned_students } = data;
		if (assigned_students && assigned_students.length) {
			this.errorAssigned = assigned_students;
			this.modalType = _MODAL_TYPE.ERROR;
		} else if (
			assigned_day_care_classes &&
			assigned_day_care_classes.length
		) {
			this.errorAssignedDayClasses = assigned_day_care_classes;
			this.modalType = _MODAL_TYPE.ERROR;
		} else if (data && data?.data) {
			this.staff = data?.data;
			this.modalIsOpen = false;
			await this.store.dispatch('setAlertMessage', {
				message: 'Khoá tài khoản thành công',
			});
		}
	}

	async activeStaff() {
		const data = await this.setup.activeStaff(this.id);
		if (data && data?.data) {
			this.modalIsOpen = false;
			this.staff = data?.data;
			await this.store.dispatch('setAlertMessage', {
				message: 'Kích hoạt tài khoản thành công',
			});
		}
	}

	selectTab(index) {
		this.tab = index;
		this.$router.replace({
			query: {
				...this.$route.query,
				tab: index,
			},
		});
	}

	prevDay() {
		const da = dayjs(new Date(this.date.year, this.date.month, 1))
			.subtract(1, 'month')
			.toDate();
		this.date = {
			month: da.getMonth(),
			year: da.getFullYear(),
		};
	}

	nextDay() {
		const da = dayjs(new Date(this.date.year, this.date.month, 1))
			.add(1, 'month')
			.toDate();
		this.date = {
			month: da.getMonth(),
			year: da.getFullYear(),
		};
	}

	async fetchStaffStats() {
		try {
			const {
				data: { data },
			} = await $api.staff.fetchDashboard(this.id, {
				date: this.datePayload,
			});

			const { weekly_report_stats } = data;

			this.dataStats = data;

			this.dataStats.weekly_report_stats = weekly_report_stats || {
				numbers_of_completed_weekly_report: 0,
				numbers_of_weekly_report: 0,
			};
		} catch (err) {
			await this.store.dispatch('setAlertMessage', {
				message: 'Cõ lỗi xảy ra, vui lòng thử lại.',
				type: 'danger',
			});
		}
	}

	async fetchStaffStatsDayCare() {
		try {
			const {
				data: { data },
			} = await $api.staff.fetchDashboardDayCare(this.id, {
				month_start: this.datePayload,
			});
			this.dataStatsDayCare = data || {};
		} catch (err) {
			await this.store.dispatch('setAlertMessage', {
				message: 'Cõ lỗi xảy ra, vui lòng thử lại.',
				type: 'danger',
			});
		}
	}

	dayOfWeekDisplay(slots) {
		return slots
			?.map((item) => (item !== 7 ? `T${item + 1}` : 'Chủ nhật'))
			.join(', ');
	}
}
</script>

<style lang="scss" scoped>
.selected {
	@apply text-yellow-700 border-yellow-500;
}

.input-date-dashboard {
	font-family: 'SVN-Gilroy', sans-serif !important;
}
</style>
